import {AxiosInstance} from "axios";


interface LoyaltyCardMembershipCreditRequest {
    type: 'point' | 'unit',
    value: number;
}

interface LoyaltyCardMembershipPurchaseRequest {
    product_id: number;
    quantity: number;
}

/**
 * The loyalty card membership credit resource.
 * @author Tony Laurent <t.laurent@apodispharma.com>
 * @param {Object} client - The injected client.
 * @returns {Object} The public object.
 */
export default function (client: AxiosInstance) {
    return {
        /**
         * Create a loyalty card membership credit.
         * @param {number} customerId - The ID of the customer.
         * @param {number} membershipId - The ID of the membership.
         * @param {Object} data -
         * @returns {Promise} Promise object represents the HTTP request.
         */
        async create(customerId: number, membershipId: number, data: LoyaltyCardMembershipCreditRequest) {
            return client
                .post(`customers/${customerId}/loyalty-card-memberships/${membershipId}/credits`, {
                    data
                })
                .then(response => response.data.data);
        },

        /**
         * Credit a hand-recorded purchase (targeted product) onto a membership.
         * @param {number} customerId - The ID of the customer.
         * @param {number} membershipId - The ID of the membership.
         * @param {Object} data - The purchased product and quantity.
         * @returns {Promise} Promise object represents the HTTP request.
         */
        async createPurchase(customerId: number, membershipId: number, data: LoyaltyCardMembershipPurchaseRequest) {
            return client
                .post(`customers/${customerId}/loyalty-card-memberships/${membershipId}/purchases`, {
                    data
                })
                .then(response => response.data.data);
        }
    };
}
